import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("ct_token")) {
      setUser(false);
      return false;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("ct_token");
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = async (path, body) => {
    const { data } = await api.post(path, body);
    localStorage.setItem("ct_token", data.token);
    return refresh();
  };

  const logout = () => {
    localStorage.removeItem("ct_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, signIn, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
